.pageContent {
  display: flex;
  gap: 1.5rem;
  min-width: 0;
  max-width: 100%;
  overflow: auto;
  height: 100%;
}

.styledCol {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 412px;
}
